import { Language } from '../format'
import countryLabelDe from './de.json'
import countryLabelEn from './en.json'

/**
 * The following list was assembled by using the following json data sets:
 * For emojis and dial codes: https://gist.githubusercontent.com/DmytroLisitsyn/1c31186e5b66f1d6c52da6b5c70b12ad/raw/01b1af9b267471818f4f8367852bd4a2814cbae6/country_dial_info.json
 */
export const countries = {
  AF: {
    dial_code: '+93',
    flag: '🇦🇫',
  },
  AX: {
    dial_code: '+358',
    flag: '🇦🇽',
  },
  AL: {
    dial_code: '+355',
    flag: '🇦🇱',
  },
  DZ: {
    dial_code: '+213',
    flag: '🇩🇿',
  },
  AS: {
    dial_code: '+1684',
    flag: '🇦🇸',
  },
  AD: {
    dial_code: '+376',
    flag: '🇦🇩',
  },
  AO: {
    dial_code: '+244',
    flag: '🇦🇴',
  },
  AI: {
    dial_code: '+1264',
    flag: '🇦🇮',
  },
  AQ: {
    dial_code: '+672',
    flag: '🇦🇶',
  },
  AG: {
    dial_code: '+1268',
    flag: '🇦🇬',
  },
  AR: {
    dial_code: '+54',
    flag: '🇦🇷',
  },
  AM: {
    dial_code: '+374',
    flag: '🇦🇲',
  },
  AW: {
    dial_code: '+297',
    flag: '🇦🇼',
  },
  AU: {
    dial_code: '+61',
    flag: '🇦🇺',
  },
  AT: {
    dial_code: '+43',
    flag: '🇦🇹',
  },
  AZ: {
    dial_code: '+994',
    flag: '🇦🇿',
  },
  BS: {
    dial_code: '+1242',
    flag: '🇧🇸',
  },
  BH: {
    dial_code: '+973',
    flag: '🇧🇭',
  },
  BD: {
    dial_code: '+880',
    flag: '🇧🇩',
  },
  BB: {
    dial_code: '+1246',
    flag: '🇧🇧',
  },
  BY: {
    dial_code: '+375',
    flag: '🇧🇾',
  },
  BE: {
    dial_code: '+32',
    flag: '🇧🇪',
  },
  BZ: {
    dial_code: '+501',
    flag: '🇧🇿',
  },
  BJ: {
    dial_code: '+229',
    flag: '🇧🇯',
  },
  BM: {
    dial_code: '+1441',
    flag: '🇧🇲',
  },
  BT: {
    dial_code: '+975',
    flag: '🇧🇹',
  },
  BO: {
    dial_code: '+591',
    flag: '🇧🇴',
  },
  BA: {
    dial_code: '+387',
    flag: '🇧🇦',
  },
  BW: {
    dial_code: '+267',
    flag: '🇧🇼',
  },
  BV: {
    dial_code: '+47',
    flag: '🇧🇻',
  },
  BR: {
    dial_code: '+55',
    flag: '🇧🇷',
  },
  IO: {
    dial_code: '+246',
    flag: '🇮🇴',
  },
  BN: {
    dial_code: '+673',
    flag: '🇧🇳',
  },
  BG: {
    dial_code: '+359',
    flag: '🇧🇬',
  },
  BF: {
    dial_code: '+226',
    flag: '🇧🇫',
  },
  BI: {
    dial_code: '+257',
    flag: '🇧🇮',
  },
  KH: {
    dial_code: '+855',
    flag: '🇰🇭',
  },
  CM: {
    dial_code: '+237',
    flag: '🇨🇲',
  },
  CA: {
    dial_code: '+1',
    flag: '🇨🇦',
  },
  CV: {
    dial_code: '+238',
    flag: '🇨🇻',
  },
  KY: {
    dial_code: '+345',
    flag: '🇰🇾',
  },
  CF: {
    dial_code: '+236',
    flag: '🇨🇫',
  },
  TD: {
    dial_code: '+235',
    flag: '🇹🇩',
  },
  CL: {
    dial_code: '+56',
    flag: '🇨🇱',
  },
  CN: {
    dial_code: '+86',
    flag: '🇨🇳',
  },
  CX: {
    dial_code: '+61',
    flag: '🇨🇽',
  },
  CC: {
    dial_code: '+61',
    flag: '🇨🇨',
  },
  CO: {
    dial_code: '+57',
    flag: '🇨🇴',
  },
  KM: {
    dial_code: '+269',
    flag: '🇰🇲',
  },
  CG: {
    dial_code: '+242',
    flag: '🇨🇬',
  },
  CD: {
    dial_code: '+243',
    flag: '🇨🇩',
  },
  CK: {
    dial_code: '+682',
    flag: '🇨🇰',
  },
  CR: {
    dial_code: '+506',
    flag: '🇨🇷',
  },
  CI: {
    dial_code: '+225',
    flag: '🇨🇮',
  },
  HR: {
    dial_code: '+385',
    flag: '🇭🇷',
  },
  CU: {
    dial_code: '+53',
    flag: '🇨🇺',
  },
  CY: {
    dial_code: '+357',
    flag: '🇨🇾',
  },
  CZ: {
    dial_code: '+420',
    flag: '🇨🇿',
  },
  DK: {
    dial_code: '+45',
    flag: '🇩🇰',
  },
  DJ: {
    dial_code: '+253',
    flag: '🇩🇯',
  },
  DM: {
    dial_code: '+1767',
    flag: '🇩🇲',
  },
  DO: {
    dial_code: '+1849',
    flag: '🇩🇴',
  },
  EC: {
    dial_code: '+593',
    flag: '🇪🇨',
  },
  EG: {
    dial_code: '+20',
    flag: '🇪🇬',
  },
  SV: {
    dial_code: '+503',
    flag: '🇸🇻',
  },
  GQ: {
    dial_code: '+240',
    flag: '🇬🇶',
  },
  ER: {
    dial_code: '+291',
    flag: '🇪🇷',
  },
  EE: {
    dial_code: '+372',
    flag: '🇪🇪',
  },
  ET: {
    dial_code: '+251',
    flag: '🇪🇹',
  },
  FK: {
    dial_code: '+500',
    flag: '🇫🇰',
  },
  FO: {
    dial_code: '+298',
    flag: '🇫🇴',
  },
  FJ: {
    dial_code: '+679',
    flag: '🇫🇯',
  },
  FI: {
    dial_code: '+358',
    flag: '🇫🇮',
  },
  FR: {
    dial_code: '+33',
    flag: '🇫🇷',
  },
  GF: {
    dial_code: '+594',
    flag: '🇬🇫',
  },
  PF: {
    dial_code: '+689',
    flag: '🇵🇫',
  },
  TF: {
    dial_code: '+262',
    flag: '🇹🇫',
  },
  GA: {
    dial_code: '+241',
    flag: '🇬🇦',
  },
  GM: {
    dial_code: '+220',
    flag: '🇬🇲',
  },
  GE: {
    dial_code: '+995',
    flag: '🇬🇪',
  },
  DE: {
    dial_code: '+49',
    flag: '🇩🇪',
  },
  GH: {
    dial_code: '+233',
    flag: '🇬🇭',
  },
  GI: {
    dial_code: '+350',
    flag: '🇬🇮',
  },
  GR: {
    dial_code: '+30',
    flag: '🇬🇷',
  },
  GL: {
    dial_code: '+299',
    flag: '🇬🇱',
  },
  GD: {
    dial_code: '+1473',
    flag: '🇬🇩',
  },
  GP: {
    dial_code: '+590',
    flag: '🇬🇵',
  },
  GU: {
    dial_code: '+1671',
    flag: '🇬🇺',
  },
  GT: {
    dial_code: '+502',
    flag: '🇬🇹',
  },
  GG: {
    dial_code: '+44',
    flag: '🇬🇬',
  },
  GN: {
    dial_code: '+224',
    flag: '🇬🇳',
  },
  GW: {
    dial_code: '+245',
    flag: '🇬🇼',
  },
  GY: {
    dial_code: '+592',
    flag: '🇬🇾',
  },
  HT: {
    dial_code: '+509',
    flag: '🇭🇹',
  },
  HM: {
    dial_code: '+672',
    flag: '🇭🇲',
  },
  VA: {
    dial_code: '+379',
    flag: '🇻🇦',
  },
  HN: {
    dial_code: '+504',
    flag: '🇭🇳',
  },
  HK: {
    dial_code: '+852',
    flag: '🇭🇰',
  },
  HU: {
    dial_code: '+36',
    flag: '🇭🇺',
  },
  IS: {
    dial_code: '+354',
    flag: '🇮🇸',
  },
  IN: {
    dial_code: '+91',
    flag: '🇮🇳',
  },
  ID: {
    dial_code: '+62',
    flag: '🇮🇩',
  },
  IR: {
    dial_code: '+98',
    flag: '🇮🇷',
  },
  IQ: {
    dial_code: '+964',
    flag: '🇮🇶',
  },
  IE: {
    dial_code: '+353',
    flag: '🇮🇪',
  },
  IM: {
    dial_code: '+44',
    flag: '🇮🇲',
  },
  IL: {
    dial_code: '+972',
    flag: '🇮🇱',
  },
  IT: {
    dial_code: '+39',
    flag: '🇮🇹',
  },
  JM: {
    dial_code: '+1876',
    flag: '🇯🇲',
  },
  JP: {
    dial_code: '+81',
    flag: '🇯🇵',
  },
  JE: {
    dial_code: '+44',
    flag: '🇯🇪',
  },
  JO: {
    dial_code: '+962',
    flag: '🇯🇴',
  },
  KZ: {
    dial_code: '+7',
    flag: '🇰🇿',
  },
  KE: {
    dial_code: '+254',
    flag: '🇰🇪',
  },
  KI: {
    dial_code: '+686',
    flag: '🇰🇮',
  },
  KP: {
    dial_code: '+850',
    flag: '🇰🇵',
  },
  KR: {
    dial_code: '+82',
    flag: '🇰🇷',
  },
  XK: {
    dial_code: '+383',
    flag: '🇽🇰',
  },
  KW: {
    dial_code: '+965',
    flag: '🇰🇼',
  },
  KG: {
    dial_code: '+996',
    flag: '🇰🇬',
  },
  LA: {
    dial_code: '+856',
    flag: '🇱🇦',
  },
  LV: {
    dial_code: '+371',
    flag: '🇱🇻',
  },
  LB: {
    dial_code: '+961',
    flag: '🇱🇧',
  },
  LS: {
    dial_code: '+266',
    flag: '🇱🇸',
  },
  LR: {
    dial_code: '+231',
    flag: '🇱🇷',
  },
  LY: {
    dial_code: '+218',
    flag: '🇱🇾',
  },
  LI: {
    dial_code: '+423',
    flag: '🇱🇮',
  },
  LT: {
    dial_code: '+370',
    flag: '🇱🇹',
  },
  LU: {
    dial_code: '+352',
    flag: '🇱🇺',
  },
  MO: {
    dial_code: '+853',
    flag: '🇲🇴',
  },
  MK: {
    dial_code: '+389',
    flag: '🇲🇰',
  },
  MG: {
    dial_code: '+261',
    flag: '🇲🇬',
  },
  MW: {
    dial_code: '+265',
    flag: '🇲🇼',
  },
  MY: {
    dial_code: '+60',
    flag: '🇲🇾',
  },
  MV: {
    dial_code: '+960',
    flag: '🇲🇻',
  },
  ML: {
    dial_code: '+223',
    flag: '🇲🇱',
  },
  MT: {
    dial_code: '+356',
    flag: '🇲🇹',
  },
  MH: {
    dial_code: '+692',
    flag: '🇲🇭',
  },
  MQ: {
    dial_code: '+596',
    flag: '🇲🇶',
  },
  MR: {
    dial_code: '+222',
    flag: '🇲🇷',
  },
  MU: {
    dial_code: '+230',
    flag: '🇲🇺',
  },
  YT: {
    dial_code: '+262',
    flag: '🇾🇹',
  },
  MX: {
    dial_code: '+52',
    flag: '🇲🇽',
  },
  FM: {
    dial_code: '+691',
    flag: '🇫🇲',
  },
  MD: {
    dial_code: '+373',
    flag: '🇲🇩',
  },
  MC: {
    dial_code: '+377',
    flag: '🇲🇨',
  },
  MN: {
    dial_code: '+976',
    flag: '🇲🇳',
  },
  ME: {
    dial_code: '+382',
    flag: '🇲🇪',
  },
  MS: {
    dial_code: '+1664',
    flag: '🇲🇸',
  },
  MA: {
    dial_code: '+212',
    flag: '🇲🇦',
  },
  MZ: {
    dial_code: '+258',
    flag: '🇲🇿',
  },
  MM: {
    dial_code: '+95',
    flag: '🇲🇲',
  },
  NA: {
    dial_code: '+264',
    flag: '🇳🇦',
  },
  NR: {
    dial_code: '+674',
    flag: '🇳🇷',
  },
  NP: {
    dial_code: '+977',
    flag: '🇳🇵',
  },
  NL: {
    dial_code: '+31',
    flag: '🇳🇱',
  },
  AN: {
    dial_code: '+599',
    flag: '',
  },
  NC: {
    dial_code: '+687',
    flag: '🇳🇨',
  },
  NZ: {
    dial_code: '+64',
    flag: '🇳🇿',
  },
  NI: {
    dial_code: '+505',
    flag: '🇳🇮',
  },
  NE: {
    dial_code: '+227',
    flag: '🇳🇪',
  },
  NG: {
    dial_code: '+234',
    flag: '🇳🇬',
  },
  NU: {
    dial_code: '+683',
    flag: '🇳🇺',
  },
  NF: {
    dial_code: '+672',
    flag: '🇳🇫',
  },
  MP: {
    dial_code: '+1670',
    flag: '🇲🇵',
  },
  NO: {
    dial_code: '+47',
    flag: '🇳🇴',
  },
  OM: {
    dial_code: '+968',
    flag: '🇴🇲',
  },
  PK: {
    dial_code: '+92',
    flag: '🇵🇰',
  },
  PW: {
    dial_code: '+680',
    flag: '🇵🇼',
  },
  PS: {
    dial_code: '+970',
    flag: '🇵🇸',
  },
  PA: {
    dial_code: '+507',
    flag: '🇵🇦',
  },
  PG: {
    dial_code: '+675',
    flag: '🇵🇬',
  },
  PY: {
    dial_code: '+595',
    flag: '🇵🇾',
  },
  PE: {
    dial_code: '+51',
    flag: '🇵🇪',
  },
  PH: {
    dial_code: '+63',
    flag: '🇵🇭',
  },
  PN: {
    dial_code: '+64',
    flag: '🇵🇳',
  },
  PL: {
    dial_code: '+48',
    flag: '🇵🇱',
  },
  PT: {
    dial_code: '+351',
    flag: '🇵🇹',
  },
  PR: {
    dial_code: '+1939',
    flag: '🇵🇷',
  },
  QA: {
    dial_code: '+974',
    flag: '🇶🇦',
  },
  RO: {
    dial_code: '+40',
    flag: '🇷🇴',
  },
  RU: {
    dial_code: '+7',
    flag: '🇷🇺',
  },
  RW: {
    dial_code: '+250',
    flag: '🇷🇼',
  },
  RE: {
    dial_code: '+262',
    flag: '🇷🇪',
  },
  BL: {
    dial_code: '+590',
    flag: '🇧🇱',
  },
  SH: {
    dial_code: '+290',
    flag: '🇸🇭',
  },
  KN: {
    dial_code: '+1869',
    flag: '🇰🇳',
  },
  LC: {
    dial_code: '+1758',
    flag: '🇱🇨',
  },
  MF: {
    dial_code: '+590',
    flag: '🇲🇫',
  },
  PM: {
    dial_code: '+508',
    flag: '🇵🇲',
  },
  VC: {
    dial_code: '+1784',
    flag: '🇻🇨',
  },
  WS: {
    dial_code: '+685',
    flag: '🇼🇸',
  },
  SM: {
    dial_code: '+378',
    flag: '🇸🇲',
  },
  ST: {
    dial_code: '+239',
    flag: '🇸🇹',
  },
  SA: {
    dial_code: '+966',
    flag: '🇸🇦',
  },
  SN: {
    dial_code: '+221',
    flag: '🇸🇳',
  },
  RS: {
    dial_code: '+381',
    flag: '🇷🇸',
  },
  SC: {
    dial_code: '+248',
    flag: '🇸🇨',
  },
  SL: {
    dial_code: '+232',
    flag: '🇸🇱',
  },
  SG: {
    dial_code: '+65',
    flag: '🇸🇬',
  },
  SK: {
    dial_code: '+421',
    flag: '🇸🇰',
  },
  SI: {
    dial_code: '+386',
    flag: '🇸🇮',
  },
  SB: {
    dial_code: '+677',
    flag: '🇸🇧',
  },
  SO: {
    dial_code: '+252',
    flag: '🇸🇴',
  },
  ZA: {
    dial_code: '+27',
    flag: '🇿🇦',
  },
  SS: {
    dial_code: '+211',
    flag: '🇸🇸',
  },
  GS: {
    dial_code: '+500',
    flag: '🇬🇸',
  },
  ES: {
    dial_code: '+34',
    flag: '🇪🇸',
  },
  LK: {
    dial_code: '+94',
    flag: '🇱🇰',
  },
  SD: {
    dial_code: '+249',
    flag: '🇸🇩',
  },
  SR: {
    dial_code: '+597',
    flag: '🇸🇷',
  },
  SJ: {
    dial_code: '+47',
    flag: '🇸🇯',
  },
  SZ: {
    dial_code: '+268',
    flag: '🇸🇿',
  },
  SE: {
    dial_code: '+46',
    flag: '🇸🇪',
  },
  CH: {
    dial_code: '+41',
    flag: '🇨🇭',
  },
  SY: {
    dial_code: '+963',
    flag: '🇸🇾',
  },
  TW: {
    dial_code: '+886',
    flag: '🇹🇼',
  },
  TJ: {
    dial_code: '+992',
    flag: '🇹🇯',
  },
  TZ: {
    dial_code: '+255',
    flag: '🇹🇿',
  },
  TH: {
    dial_code: '+66',
    flag: '🇹🇭',
  },
  TL: {
    dial_code: '+670',
    flag: '🇹🇱',
  },
  TG: {
    dial_code: '+228',
    flag: '🇹🇬',
  },
  TK: {
    dial_code: '+690',
    flag: '🇹🇰',
  },
  TO: {
    dial_code: '+676',
    flag: '🇹🇴',
  },
  TT: {
    dial_code: '+1868',
    flag: '🇹🇹',
  },
  TN: {
    dial_code: '+216',
    flag: '🇹🇳',
  },
  TR: {
    dial_code: '+90',
    flag: '🇹🇷',
  },
  TM: {
    dial_code: '+993',
    flag: '🇹🇲',
  },
  TC: {
    dial_code: '+1649',
    flag: '🇹🇨',
  },
  TV: {
    dial_code: '+688',
    flag: '🇹🇻',
  },
  UG: {
    dial_code: '+256',
    flag: '🇺🇬',
  },
  UA: {
    dial_code: '+380',
    flag: '🇺🇦',
  },
  AE: {
    dial_code: '+971',
    flag: '🇦🇪',
  },
  GB: {
    dial_code: '+44',
    flag: '🇬🇧',
  },
  US: {
    dial_code: '+1',
    flag: '🇺🇸',
  },
  UY: {
    dial_code: '+598',
    flag: '🇺🇾',
  },
  UZ: {
    dial_code: '+998',
    flag: '🇺🇿',
  },
  VU: {
    dial_code: '+678',
    flag: '🇻🇺',
  },
  VE: {
    dial_code: '+58',
    flag: '🇻🇪',
  },
  VN: {
    dial_code: '+84',
    flag: '🇻🇳',
  },
  VG: {
    dial_code: '+1284',
    flag: '🇻🇬',
  },
  VI: {
    dial_code: '+1340',
    flag: '🇻🇮',
  },
  WF: {
    dial_code: '+681',
    flag: '🇼🇫',
  },
  YE: {
    dial_code: '+967',
    flag: '🇾🇪',
  },
  ZM: {
    dial_code: '+260',
    flag: '🇿🇲',
  },
  ZW: {
    dial_code: '+263',
    flag: '🇿🇼',
  },
} as const

export type AvailableCountryCodes = keyof typeof countries

export type Countries = Record<
  AvailableCountryCodes,
  {
    dial_code: string
    flag: string
  }
>
/**
 * The following list was assembled by using the following json data sets:
 *     de: https://github.com/marcbachmann/localized-countries/blob/master/data/de.json
 *     en: https://github.com/marcbachmann/localized-countries/blob/master/data/en.json
 *  although we needed to add AN and XK manually
 */
export const countriesTranslations: Record<Language, Record<AvailableCountryCodes, string>> = {
  [Language.De]: countryLabelDe,
  [Language.En]: countryLabelEn,
} as const
